<template>
  <div class="input__wrap" :style="`width: ${width}`" :disabled="disabled">
    <span class="input__text" v-if="title"
      >{{ title }}{{ required ? "*" : "" }}</span
    >
    <div class="colors">
      <div
        v-show="withDefaultsColors"
        v-for="(color, i) in colors"
        :key="i + 'color'"
        :class="['colors__item', { active: inputValue === color }]"
        @click="setDedaultValue(color)"
      >
        <span class="colors__item-value" :style="`background: ${color}`" />
      </div>
      <input
        class="input"
        :class="[classObject, { active: $refs.input && inputValue === $refs.input.value }]"
        type="color"
        :disabled="disabled"
        :required="required"
        :placeholder="placeholder"
        :value="inputValue"
        ref="input"
        @change="valueChanged"
        @focus="focused"
        @keyup.enter.prevent="keyupEnter"
        :tabindex="1"
        :style="withDefaultsColors ? 'width: 40px' : null"
      />
    </div>

    <transition name="scaleDown">
      <span
        v-if="valid.type"
        class="input__valid"
        :class="'input__valid_' + valid.type"
      >
        <img
          v-if="valid.type === 'error'"
          src="/img/svg/error_icon.svg"
          alt="Ошибка"
          class="input__valid__icon"
        />
        <img
          v-if="valid.type === 'warning'"
          src="/img/svg/warning_icon.svg"
          alt="Внимание"
          class="input__valid__icon"
        />
        <img
          v-if="valid.type === 'success'"
          src="/img/svg/success_icon.svg"
          alt="Успешно"
          class="input__valid__icon"
        />
      </span>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app-color-picker',
  props: {
    title: String,
    placeholder: String,
    value: String,
    disabled: Boolean,
    required: Boolean,
    valid: {
      type: Object,
      default: () => {
        return { type: null, message: '' }
      }
    },
    width: {
      type: String,
      default: '40px'
    },
    flat: Boolean,
    borderless: Boolean,
    withDefaultsColors: Boolean
  },
  data () {
    return {
      defaultValue: this.value,
      colors: [
        '#1ABC9C',
        '#16A085',
        '#2ECC71',
        '#27AE60',
        '#3498DB',
        '#2980B9',
        '#8E44AD',
        '#2B3E50',
        '#F1C40F',
        '#F39C12',
        '#D35400',
        '#E74C3C',
        '#BDC3C7',
        '#95A5A6',
        '#7F8C8D',
        '#EB219A',
        '#A8CE4A'
      ]
    }
  },
  methods: {
    showPassword () {
      this.$refs.showPassButton.classList.toggle(
        'input-password__showpass-btn_active'
      )
      if (this.$refs.input.getAttribute('type') === 'password') {
        this.$refs.input.setAttribute('type', 'text')
      } else {
        this.$refs.input.setAttribute('type', 'password')
      }
    },
    valueChanged () {
      this.inputValue = this.$refs.input.value
    },
    setDedaultValue (value) {
      this.inputValue = value
    },
    focused () {
      this.inputValue = this.$refs.input.value
      this.$emit('got-focus')
    },
    keyupEnter () {
      this.$emit('keyup-enter')
    }
  },
  computed: {
    classObject () {
      return {
        flat: this.flat,
        borderless: this.borderless,
        'input-password': this.isPassword,
        input_error: this.valid !== {} && this.valid.type === 'error',
        input_warning: this.valid !== {} && this.valid.type === 'warning',
        input_success: this.valid !== {} && this.valid.type === 'success'
      }
    },
    inputValue: {
      get () {
        return this.value || this.defaultValue
      },
      set (val) {
        this.defaultValue = val
        this.$emit('value-changed', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.input {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 40px;
  color: $font_color_second;
  border: 2px solid $color__forest-wolf;
  border-radius: 3px;
  transition: .2s border-color ease-in-out;
  font: inherit;
  cursor: pointer;

  &__wrap {
    position: relative;
    display: block;

    &[disabled] {
      pointer-events: none;

      .input__text {
        color: $color_deactive;
      }

      .input {
        border: 1px solid $color_deactive;
      }
    }
  }

  &__text {
    display: block;
    margin-bottom: 10px;
    color: $font_color_second;
  }

  &__valid {
    display: block;
    position: absolute;
    z-index: 99;
    top: auto;
    bottom: auto;
    transform: translateY(-5px) scaleY(1);
    transform-origin: top;
    left: 0;
    width: 100%;
    font-size: 14px;
    //padding: 5px 15px 0 15px;
    color: $font_color_alt;
    border-radius: 0 0 3px 3px;
    transition: 0.3s;

    &__icon {
      position: absolute;
      top: calc(50% - 29.5px);
      left: auto;
      right: -35px;
      animation: fadeIn 0.3s linear;
    }

    //&_error {
    //  background-color: $color_error;
    //}

    &_warning {
      background-color: $color_warning;
    }

    &_success {
      background-color: $color_success;
    }
  }

  &_error {
    border: 1px solid $color_error;
  }

  &_warning {
    border: 1px solid $color_warning;
  }

  &_succes {
    border: 1px solid $color_success;
  }

  &[disabled] {
    background: $color_main;
  }

  &:hover {
    border: 2px solid $color__orange;
  }

  &:focus {
    box-shadow: inset 0 4px 4px rgba(23, 63, 125, 0.25);
  }

  &.active {
    border: 2px solid $color__copper-pink;
  }

  &.flat {
    border: none;

    &:hover {
      border: none;
    }

    &:focus {
      box-shadow: none;
    }
  }

  &.borderless {
    border: none;

    &:hover {
      border: none;
    }
  }

}

.colors {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  column-gap: 9px;
  row-gap: 9px;

  .colors__item {
    display: flex;
    width: 40px;
    height: 40px;
    padding: 6px 5px;
    background: #efefef;
    border: 1px solid $color_third-dark;
    border-radius: 3px;
    cursor: pointer;

    &:hover {
      border: 2px solid $color_second-light;
    }
    &.active {
      border: 2px solid $color_second-light;
    }

    .colors__item-value {
      display: flex;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
